import React from 'react';
import useDebugTools from '../../hooks/useDebugTools';

// Always-visible warning whenever testing shortcuts are enabled for this session
// (DEBUG_TOOLS=true, or a player test account), so they can't go unnoticed.
function DebugBanner() {
  const debugTools = useDebugTools();
  if (!debugTools) return null;
  return (
    <div
      role="alert"
      style={{
        background: '#b71c1c', color: '#fff', textAlign: 'center',
        fontSize: 12, fontWeight: 700, padding: '2px 8px', letterSpacing: 0.5,
      }}
    >
      DEBUG MODE: testing shortcuts are enabled for this account (test accounts / DEBUG_TOOLS only)
    </div>
  );
}

export default DebugBanner;
